import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import { isNavOpen } from 'store/nav';

import { PaymentMethod } from 'components';
import {
  Navigation,
  TopBar,
  Overview,
  GetDiscountContainer,
  Account,
  ContactContainer,
  Help
} from 'containers';

export const Main = ({ isNavOpen }) => (
  <div>
    <div className={`layout__nav${isNavOpen ? ' layout__nav--open' : ''}`}>
      <Navigation />
    </div>

    <div className="layout__main">
      <TopBar />

      <Switch>
        <Route path="/overview" component={Overview} />
        <Route path="/get-discount" component={GetDiscountContainer} />
        <Route path="/account" component={Account} />
        <Route path="/payment-method" component={PaymentMethod} />
        <Route path="/contact" component={ContactContainer} />
        <Route path="/help" component={Help} />
        <Route render={() => <Redirect to="/overview" />} />
      </Switch>
    </div>
  </div>
);

Main.propTypes = {
  isNavOpen: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  isNavOpen: isNavOpen(state)
});

export default withRouter(connect(mapStateToProps)(Main));



// WEBPACK FOOTER //
// ./src/containers/Main/Main.js